module.exports = __webpack_public_path__ + "static/media/previewSenderBg.e893f896.svg";